import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import Masonry from 'react-masonry-component';
import Store from 'SharedComponents/store-card';
import DropdownSelect from 'SharedComponents/dropdown-select';
import Pagination from 'SharedComponents/pagination';

import styles from './index.css.js';

const StoresWrapper = styled.div`${styles}`;

const sortingOptions = [
  {
    label: 'Alphabetical',
    value: 'alphabetical',
  },
  {
    label: 'Most Popular',
    value: 'popularity',
  },
];

const MOBILE_BREAKPOINT = 768;

const Stores = ({
  items,
  searchTerm,
  selectedCategory,
  onShopNow,
  onSetSharedItem,
  setFavShops,
}) => {
  const [sorting, setSorting] = useState('popularity');
  const [pageItems, setPageItems] = useState([]);
  const [isMobileLayout, setIsMobileLayout] = useState(window.innerWidth <= MOBILE_BREAKPOINT);

  useEffect(() => {
    const onResize = () => {
      setIsMobileLayout(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const sortedItems = useMemo(() => {
    const nextItems = [...items];

    if (sorting === 'alphabetical') {
      nextItems.sort((a, b) => a.merchant_name.localeCompare(b.merchant_name));
      return nextItems;
    }

    nextItems.sort((a, b) => parseInt(b.clicks, 10) - parseInt(a.clicks, 10));
    return nextItems;
  }, [items, sorting]);

  return (
    <StoresWrapper>
      <div className="header">
        <div className="description">
          <p className="header-text">Click through and purchase from these shops to Boost Your Super</p>
        </div>

        <div className="sorter">
          <div className="visible-items">
            {selectedCategory ? (
              <span className="matches">
                Showing shops in
                {' '}
                {selectedCategory}
                {' '}
                category
              </span>
            ) : searchTerm && searchTerm.length ? (
              <span className="matches">
                Showing shops matching
                {' '}
                <span className="matched-term">{searchTerm}</span>
                {' '}
                search term
              </span>
            ) : (
              <span className="matches">
                Showing
                {' '}
                <span style={{ fontWeight: 'bold' }}>all</span>
                {' '}
                shops
              </span>
            )}
          </div>

          <DropdownSelect
            className="dropdown-menu"
            value={sorting}
            onChange={(option) => {
              if (option.value !== sorting) {
                setSorting(option.value);
              }
            }}
            options={sortingOptions}
          />
        </div>
      </div>

      <div className="stores-container">
        <Masonry
          className="stores-masonry-container"
          options={{
            isFitWidth: isMobileLayout,
            transitionDuration: '0.7s',
            stagger: 100,
          }}
        >
          {pageItems.map((store) => (
            <Store
              store={store}
              key={store.retail_store_id}
              onShopNow={onShopNow}
              onSetSharedItem={onSetSharedItem}
              setFavShops={setFavShops}
            />
          ))}
        </Masonry>
      </div>

      <Pagination
        pageSize={24}
        items={sortedItems}
        onChangePage={(visibleItems) => {
          setPageItems(visibleItems);
        }}
        sorting={sorting}
      />
    </StoresWrapper>
  );
};

export default Stores;
